module.exports = "../dist/img/product-card-.bf51.jpg";